import React, { useState } from "react";
import { useFormik } from "formik";
import { Link, useParams } from "react-router-dom";
import { Logo } from "../_components/Imagepath";
// import * as Yup from "yup";
import axios from "../api/axios";
import {  Apitoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const ResetPassword = () => {
  const { token } = useParams();
  const [eye, seteye] = useState(true);
  const [backendErrors, setBackendErrors] = useState([]);
  const [backendSuccess, setBackendSuccess] = useState(false);

  const {
    values,
    errors,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
   

    onSubmit: (values, actions) => {
      axios
        .post(
          "/reset-password",
          {
            token: token,
            password: values.password,
            password_confirmation: values.confirmPassword,
          },
          {
            headers: {
              Apitoken: Apitoken,
            },
          }
        )
        .then((response) => {
          // let data = response.data;
        

          actions.setSubmitting(false);


          delete backendErrors['error'];
          if (response.data.code === 200) {
            toast.success(response.data.message);
            setBackendSuccess(response.data.message);
            actions.resetForm();
            setTimeout(() => {
              window.location.href = "/login";
            }, 1000);

          }
          else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
        }
         
        })
        .catch((errors) => {
          console.log(errors);
          actions.setSubmitting(false);
          setBackendErrors("An error occurred. Please try again later.");
        });
    },
  });
  const onEyeClick = () => {
    seteye(!eye);
  };
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };


  return (
    <div className="main-wrapper login-body">
      <div className="login-wrapper">
        <div className="container">
          <ToastContainer />
          <img className="img-fluid logo-dark mb-2" src={Logo} alt="Logo" />

          <div className="loginbox">
            <div className="login-right">
              <div className="login-right-wrap">
                <h1>Reset Password?</h1>
                <p className="account-subtitle">Enter your new password</p>

                {/* Form */}
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label className="form-control-label">Password</label>
                    <div className="pass-group">
                      <input
                        type={eye ? "password" : "text"}
                        name="password"
                        id="password"
                        className={
                          errors.password
                            ? "form-input form-control input-error"
                            : "form-input form-control"
                        }
                        placeholder="Password"
                        value={values.password}
                        onChange={(e) => {
                          handleChange(e);
                          customHandleInput(e);
                        }}
                        onBlur={handleBlur}
                      />
                      <span style={{display:'none'}}
                        onClick={onEyeClick}
                        className={`fa toggle-password" ${
                          eye ? "fa-eye-slash" : "fa-eye"
                        }`}
                      />
                    </div>
                    <small>
                    
                      {backendErrors.password &&  (
                        <span className="form-error mt-1">
                          {backendErrors.password}
                        </span>
                      )}
                    </small>
                  </div>
                  <div className="form-group">
                    <label className="form-control-label">
                      Confirm Password
                    </label>
                    <div className="pass-group">
                      <input
                        type={eye ? "password" : "text"}
                        name="confirmPassword"
                        id="confirmPassword"
                        className={
                          errors.confirmPassword
                            ? "form-input form-control input-error"
                            : "form-input form-control"
                        }
                        placeholder="Password"
                        value={values.confirmPassword}
                        onChange={(e) => {
                          handleChange(e);
                          customHandleInput(e);
                        }}
                        onBlur={handleBlur}
                      />
                      <span  style={{display:'none'}}
                        onClick={onEyeClick}
                        className={`fa toggle-password" ${
                          eye ? "fa-eye-slash" : "fa-eye"
                        }`}
                      />
                    </div>
                    <small>
                      {backendErrors.confirmPassword  && (
                        <p className="form-error mt-1">
                          {backendErrors.confirmPassword}
                        </p>
                      )}
                        {backendErrors.error  && (
                          <span className="form-error mt-1">
                            {backendErrors.error}
                          </span>  )}
                            {backendSuccess && (
                          <span className="from-success mt-1">
                            {backendSuccess}
                          </span> )} 
                    </small>
                  </div>
                  <div className="form-group mb-0">
                    <button
                      disabled={isSubmitting}
                      className="btn btn-lg btn-block w-100 btn-primary w-100"
                      type="submit" id="form-submit"
                    >
                      Reset Password
                    </button>
                  </div>
                </form>

                <div className="text-center dont-have">
                  Back to login? <Link to="/login">Login</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ResetPassword;
